import SwivuSortColumn from "./SwivuSortColumn.jsx";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { getCustomGroupRenderer, showArchiveRecordAlert } from "../../other/utils/utils.jsx";
import { ColumnStore } from "@bryntum/schedulerpro";
import { getIsArchivedForBoard, tagWidget } from "../../other/utils/otherUtils.jsx";
import { getSavedBoardSelection } from "../../react/hooks/useBoards.jsx";

class ClientColumn extends SwivuSortColumn {

  static get fields() {
    return [
      { name: "swivuListTitle",type: "string", readOnly: true, defaultValue: "Client" },
      { name: "swivuListSearchKey",type: "string", readOnly: true, defaultValue: "name" },
      { name: "popupCls",type: "array", readOnly: true, defaultValue: ["minimal-gradient-editor"] },
    ]
  }

  static get $name() {
    return "ClientColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnTaskClient;
  }

  static get defaults() {
    return {
      text: "Client",
      field: "clientName",
      editor: false,
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      groupRenderer(e) {
        return getCustomGroupRenderer(e, 'clientName');
      },
    };
  }

  onLoad(project, { editorHandler }) {
    this.project = project;
    this.editorHandler = editorHandler;
  }

  get canMultiSelectSwivuList() {
    return false;
  }

  get swivuListItems() {
    const selectedBoard = getSavedBoardSelection();
    const canShowArchivedRecords = getIsArchivedForBoard(selectedBoard.slug);
    return this.project.getCrudStore(STORE_KEYS.clientStore).query((record) => canShowArchivedRecords || !record.archived, true);
  }

  getSwivuListItemDisplayValue(record) {
    return record.name;
  }

  getSelectedSwivuListItem(record) {
    return record.clientId;
  }

  onSwivuListSelectionChange(record, selectedRecords) {
    if (selectedRecords.length) {
      return record.clientId = selectedRecords[0].id;
    }
    return record.clientId = null;
  }

  renderer({ record }) {
    return tagWidget(record.clientName);
  }

  onSwivuBeforeListSelectionChange(record, clientRecordsToLink) {
    return !(showArchiveRecordAlert(record) || showArchiveRecordAlert(clientRecordsToLink));
  }
}

ColumnStore.registerColumnType(ClientColumn);